
import React from 'react';
import { Phone, Mail, MapPin, CheckCircle } from 'lucide-react';

const ContactInfo = () => {
  return (
    <div>
      <div className="mb-6 rounded-lg overflow-hidden shadow-md">
        <img 
          src="/lovable-uploads/731c21c2-d13e-44b1-bf13-218592953c97.png" 
          alt="Ons kantoor in Aalst" 
          className="w-full h-auto rounded-lg"
          loading="lazy"
          width="600"
          height="400"
        />
      </div>
      
      <h2 className="text-3xl font-bold mb-6 text-gray-900">
        Groei je KMO met kwalitatieve afspraken
      </h2>
      <p className="text-gray-700 mb-6">
        Klaar om jouw verkoop naar een hoger niveau te tillen? Vul het formulier in en een van onze specialisten neemt vrijblijvend contact met je op voor een persoonlijk groeiplan.
      </p>
      
      <div className="space-y-6 mb-8">
        <div className="flex items-start gap-3">
          <div className="text-brand-blue mt-1">
            <CheckCircle size={20} aria-hidden="true" />
          </div>
          <p className="text-gray-700">Antwoord binnen 2 uur op werkdagen</p>
        </div>
        <div className="flex items-start gap-3">
          <div className="text-brand-blue mt-1">
            <CheckCircle size={20} aria-hidden="true" />
          </div>
          <p className="text-gray-700">Gratis groeiplan op maat voor je KMO</p>
        </div>
        <div className="flex items-start gap-3">
          <div className="text-brand-blue mt-1">
            <CheckCircle size={20} aria-hidden="true" />
          </div>
          <p className="text-gray-700">Geen langdurige verplichtingen, starten kan al binnen een week</p>
        </div>
      </div>
      
      <ContactDetails />
    </div>
  );
};

const ContactDetails = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-start gap-4">
        <div className="bg-brand-blue p-3 rounded-full text-white">
          <Phone size={20} aria-hidden="true" />
        </div>
        <div>
          <h3 className="font-semibold text-gray-900 mb-1">Telefoon</h3>
          <p className="text-gray-700">
            <a href="tel:+3253682521" className="hover:text-brand-blue transition-colors">+32 53 68 25 21</a>
          </p>
        </div>
      </div>
      
      <div className="flex items-start gap-4">
        <div className="bg-brand-blue p-3 rounded-full text-white">
          <Mail size={20} aria-hidden="true" />
        </div>
        <div>
          <h3 className="font-semibold text-gray-900 mb-1">E-mail</h3>
          <p className="text-gray-700">
            <a href="mailto:info@afsprakenmaker.be" className="hover:text-brand-blue transition-colors">info@afsprakenmaker.be</a>
          </p>
        </div>
      </div>
      
      <div className="flex items-start gap-4">
        <div className="bg-brand-blue p-3 rounded-full text-white">
          <MapPin size={20} aria-hidden="true" />
        </div>
        <div>
          <h3 className="font-semibold text-gray-900 mb-1">Kantoor</h3>
          <address className="text-gray-700 not-italic">
            Moorselbaan 391<br />
            9300 Aalst<br />
            België
          </address>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
